import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  Icon,
  UilPhoneVolume,
  UilDashboard,
  UilAward,
  UilBright,
  UilRocket
} from '@iconscout/react-unicons';

// Definiciones de interfaces para las rutas
export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  requiresAuth?: boolean;
  allowedRoles?: string[];
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
  requiresAuth?: boolean;
  allowedRoles?: string[];
}

export const routes: RouteItems[] = [
  {
    requiresAuth: false,
    label: 'HVA Calling Management',
    horizontalNavLabel: 'HVA Calling Management',
    active: true,
    icon: UilPhoneVolume,
    labelDisabled: false,
    pages: [
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN'],
        icon: 'power',
        name: 'Start/Stop-campaigns',
        path: '/hvasystem/startstop',
        pathName: 'start-stop-campaign',
        //topNavIcon: 'shopping-cart',
        active: true
      },
      {
        requiresAuth: false,
        icon: 'phone-call',
        name: 'actual-calling',
        path: '/',
        pathName: 'actual-calling',
        active: true
      },
      {
        requiresAuth: false,
        icon: 'crosshair',
        name: 'Recording explorer',
        path: '/hvasystem/recordingexplorer',
        pathName: 'recording-explorer',
        active: true
      },
      {
        requiresAuth: false,
        name: 'campaign-management',
        icon: 'grid',
        // dropdownInside: true,
        active: true,
        pages: [
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'Call List Uploading',
            path: '/hvasystem/calllistuploading',
            pathName: 'call-list-uploading',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN', 'OPSADMIN'],
            name: 'Customer List',
            path: '/hvasystem/customerlist',
            pathName: 'customer-list',
            active: true
          }
        ]
      }
    ]
  },
  {
    requiresAuth: false,
    label: 'Reporting',
    icon: UilDashboard,
    active: true,
    //megaMenu: true,
    pages: [
      {
        requiresAuth: true,
        name: 'Call Results Report',
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN'],
        icon: 'activity',
        path: '/hvareporting/callresultsreport',
        pathName: 'callresultsreport',
        active: true
      },
      {
        requiresAuth: false,
        name: 'Campaign performance',
        icon: 'bar-chart-2',
        path: '/hvareporting/campaignperformance',
        pathName: 'campaignperformance',
        active: true
      },
      {
        requiresAuth: true,
        name: 'Script effectiveness',
        allowedRoles: ['NONE'],
        icon: 'message-circle',
        path: '/commingsoon',
        pathName: 'register-user',
        active: true
      }
    ]
  },
  {
    requiresAuth: true,
    allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN', 'QAMEMBER'],
    label: 'Quality Assurance',
    icon: UilAward,
    active: false,
    pages: [
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN', 'QAMEMBER'],
        name: 'Scorecard-dashboard',
        icon: 'award',
        path: '/hvaqualityassurance/qadashboard',
        pathName: 'qadashboard',
        active: true
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN', 'QAMEMBER'],
        name: 'Risk dashboard',
        icon: 'alert-triangle',
        path: '/hvaqualityassurance/riskdashboard',
        pathName: 'riskdashboard',
        active: true
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN', 'QAMEMBER'],
        name: 'Risk review',
        icon: 'voicemail',
        path: '/hvaqualityassurance/riskreview',
        pathName: 'riskreview',
        active: true
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'OPSADMIN', 'QAADMIN', 'QAMEMBER'],
        name: 'Call analysis',
        icon: 'thermometer',
        path: '/hvaqualityassurance/callanalysis',
        pathName: 'callanalysis',
        active: true
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN', 'QAADMIN'],
        name: 'QA configuration',
        icon: 'check-circle',
        active: true,
        pages: [
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN', 'QAADMIN'],
            name: 'Scorecard management',
            path: '/hvaqualityassurance/scorecardmanagement',
            pathName: 'scorecardmanagement',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN', 'QAADMIN'],
            name: 'Risk management',
            path: '/hvaqualityassurance/riskmanagement',
            pathName: 'riskmanagement',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'Campaign assignment',
            path: '/hvaqualityassurance/scorecardassignment',
            pathName: 'scorecardassignment',
            active: true
          }
        ]
      }
    ]
  },
  {
    requiresAuth: true,
    allowedRoles: ['SYSTEMADMIN'],
    label: 'Boost Center',
    icon: UilRocket,
    active: true,
    pages: [
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN'],
        name: 'QA processor',
        icon: 'refresh-cw',
        path: '/hvaqualityassurance/qaprocessorlog',
        pathName: 'qaprocessor',
        active: true
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN'],
        name: 'Knowledge Hub',
        icon: 'database',
        path: '/knowledgehub',
        pathName: 'knowledgehub',
        active: true
      }
    ]
  },
  {
    requiresAuth: false,
    label: 'System Configuration',
    icon: UilBright,
    active: true,
    pages: [
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN'],
        name: 'security-management',
        icon: 'shield',
        active: true,
        pages: [
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'System-dashboard',
            path: '/system-management/system-dashboard',
            pathName: 'system-dashboard',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'System-log',
            path: '/system-management/system-log',
            pathName: 'system-log',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'Create-New-Account',
            path: '/user-management/register-user',
            pathName: 'register-user',
            active: true
          }
        ]
      },
      {
        requiresAuth: true,
        allowedRoles: ['SYSTEMADMIN'],
        name: 'Services & campaigns',
        icon: 'layers',
        active: true,
        pages: [
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'service-management',
            path: '/campaign/service-management',
            pathName: 'service-management',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'campaign-management',
            path: '/campaign/campaign-management',
            pathName: 'campaign-management',
            active: true
          },
          {
            requiresAuth: true,
            allowedRoles: ['SYSTEMADMIN'],
            name: 'Access-management',
            path: '/campaign/access-management',
            pathName: 'campaign-access-management',
            active: true
          }
        ]
      },
      {
        requiresAuth: false,
        name: 'HVAs',
        icon: 'cpu',
        active: true,
        hasNew: false,
        pages: [
          {
            requiresAuth: false,
            name: 'Showroom',
            path: '/system/hvas',
            pathName: 'Showroom',
            active: true
          },
          {
            requiresAuth: true,
            name: 'POC playground',
            allowedRoles: ['SYSTEMADMIN'],
            active: true,
            hasNew: false,
            pages: [
              {
                requiresAuth: true,
                name: 'POC Greece',
                allowedRoles: ['NONE'],
                path: '/system/poc/greece',
                pathName: 'POC Greece',
                active: true
              },
              {
                requiresAuth: true,
                name: 'ubimia',
                allowedRoles: ['SYSTEMADMIN'],
                path: '/system/hvapocubimia',
                pathName: 'pfstech',
                active: true
              },
              {
                requiresAuth: true,
                name: 'Servinform',
                allowedRoles: ['NONE'],
                path: '/system/hvapocservinform',
                pathName: 'Servinform',
                active: true
              },
              {
                requiresAuth: true,
                name: 'Keldai/ProaProtech',
                allowedRoles: ['NONE'],
                path: '/system/hvapocexamplescenarios',
                pathName: 'Keldai/ProaProtech',
                active: true
              }
            ]
          },
          {
            requiresAuth: true,
            name: 'Agent Management',
            allowedRoles: ['SYSTEMADMIN'],
            path: '/system/conversationalengine/agentmanagement',
            pathName: 'Agent management',
            active: true
          },
          {
            requiresAuth: true,
            name: 'AI Deployments',
            allowedRoles: ['SYSTEMADMIN'],
            path: '/system/conversationalengine/aimodelsmanagement',
            pathName: 'AI Deployments',
            active: true
          }
        ]
      },
      {
        requiresAuth: false,
        name: 'faq',
        icon: 'help-circle',
        path: '/system/faq',
        pathName: 'faq',
        active: true
      },
      {
        requiresAuth: false,
        name: 'user-profile',
        icon: 'user',
        path: '/user-management/user-profile',
        pathName: 'user-profile',
        active: true
      }
    ]
  }
];
